import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import nacholab.supplies.pages.HomePage as _nacholab_supplies_pages_HomePage

public fun main() {
    AppGlobals.initialize(mapOf("title" to "NachoLab's Supplies"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register(
            "/",
        ) { pageCtx -> 
            _nacholab_supplies_pages_HomePage()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("common-styles_hover-pointer", nacholab.supplies.ui.theme.CommonStyles.hoverPointer)
        ctx.theme.registerStyle("common-styles_hover-primary-variant", nacholab.supplies.ui.theme.CommonStyles.hoverPrimaryVariant)
        ctx.theme.registerStyle("common-styles_color-primary", nacholab.supplies.ui.theme.CommonStyles.colorPrimary)
        ctx.theme.registerStyle("common-styles_color-secondary-variant", nacholab.supplies.ui.theme.CommonStyles.colorSecondaryVariant)
        ctx.theme.registerKeyframes("spinner-animation", nacholab.supplies.components.spinnerAnimationKeyframes)
        nacholab.supplies.initStyles(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo("/" + BasePath.remove(window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        nacholab.supplies.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
